import { createGlobalStyle } from 'styled-components';

// html/body/#root に height:100% を連鎖させ、Layout の 100vh コンテナがビューポートと一致するようにする。
// body の margin:0 はブラウザ既定マージンを除去する（height 連鎖とは独立した目的）。
export const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    margin: 0;
  }
`;
